import { createSelector } from 'reselect';

const selectMarketIndexesReducer = state => state.marketIndexes;

export const selectIndexesValues = createSelector(
  [selectMarketIndexesReducer],
  indexes => indexes.indexesValues
);

export const selectBulkValues = createSelector(
  [selectMarketIndexesReducer],
  indexes => indexes.bulkValues
);
